export enum CampaignType {
  PRODUCT = 'PRODUCT',
  CATEGORY = 'CATEGORY',
  ACTIVITY = 'ACTIVITY',
  BUNDLE_ACTIVITY = 'BUNDLE_ACTIVITY',
  BUNDLE_PRODUCT = 'BUNDLE_PRODUCT'
}

/**
 * Kampanya tablosu iki ayrı sayfada kullanılır: "Kampanyalar" (indirimler ve
 * kombo fiyat) ve "Paketler" (müşterinin satın alıp hakkını kullandığı
 * etkinlik paketleri). Veri modeli aynı (Campaign + Bundle); ayrım yalnızca
 * hangi türlerin hangi sayfada listelenip oluşturulduğudur.
 */
export type CampaignListKind = 'campaign' | 'package';

/** "Paketler" sayfasında yönetilen türler. */
export const PACKAGE_CAMPAIGN_TYPES: CampaignType[] = [
  CampaignType.BUNDLE_ACTIVITY
];

/** "Kampanyalar" sayfasında yönetilen türler. */
export const DISCOUNT_CAMPAIGN_TYPES: CampaignType[] = Object.values(
  CampaignType
).filter((type) => !PACKAGE_CAMPAIGN_TYPES.includes(type));

export const campaignTypesFor = (kind: CampaignListKind): CampaignType[] =>
  kind === 'package' ? PACKAGE_CAMPAIGN_TYPES : DISCOUNT_CAMPAIGN_TYPES;

export const isPackageCampaignType = (type?: string | null): boolean =>
  !!type && PACKAGE_CAMPAIGN_TYPES.includes(type as CampaignType);

/** Kampanyanın türüne göre ait olduğu yönetim sayfası. */
export const campaignBasePath = (type?: string | null): string =>
  isPackageCampaignType(type)
    ? '/management/packages'
    : '/management/campaigns';
